import { Fragment } from "react";
import "../App.css";
import { useState } from "react";
import Header from "../components/Header&Footer/Header";
import Hero from "../components/HomePage/hero/Hero";
import Newsletter from "../components/HomePage/newsletter/Newsletter";
import Footer from "../components/Header&Footer/Footer";
import Featured from "../components/HomePage/Featured";
import Categories from "../components/HomePage/categories/categories";

const Home = (props) => {
  const [modal, setModal] = useState(false);

  return (
    <Fragment>
      <Header
        formData={props.formData}
        setFormData={props.setFormData}
        setModal={setModal}
      />
      <Hero />
      <Featured />
      <Categories />
      <Newsletter isLoading={props.isLoading} />
      <Footer />
    </Fragment>
  );
};

export default Home;
